import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export interface IDeactivateSiteEncryptionDataKeyParams {
  dataKeyId: string;
}

export interface DeactivateSiteEncryptionDataKeyResult extends IResult {}

export class DeactivateSiteEncryptionDataKeyRequest extends Request<IDeactivateSiteEncryptionDataKeyParams, DeactivateSiteEncryptionDataKeyResult> {
  constructor(params: IDeactivateSiteEncryptionDataKeyParams) {
    super('deactivateSiteEncryptionDataKey', params);
  }
}